import BrowserSupportIndicator from './BrowserSupportIndicator';

export default BrowserSupportIndicator;
